module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "warning-block"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊")]), _vm._v("\n    例外訂單管理功能已搬至「\n    "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_vm._v("訂單管理 > 例外訂單")]), _vm._v("\n    」，請至新後台管理系統操作、檢視相關內容，此區域(舊後台)功能即將關閉。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('order-exception-table')], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42b2aa6f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Order/OrderExceptionTable.vue
// module id = 2393
// module chunks = 1